import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStreaming: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="streaming, live, stream">
      <path
        d="M3 5V4H2V5H3ZM21 5H22V4H21V5ZM21 19V20H22V19H21ZM3 19H2V20H3V19ZM13.25 10.75C13.25 11.4404 12.6904 12 12 12V14C13.7949 14 15.25 12.5449 15.25 10.75H13.25ZM12 12C11.3096 12 10.75 11.4404 10.75 10.75H8.75C8.75 12.5449 10.2051 14 12 14V12ZM10.75 10.75C10.75 10.0596 11.3096 9.5 12 9.5V7.5C10.2051 7.5 8.75 8.95507 8.75 10.75H10.75ZM12 9.5C12.6904 9.5 13.25 10.0596 13.25 10.75H15.25C15.25 8.95507 13.7949 7.5 12 7.5V9.5ZM3 6H21V4H3V6ZM20 5V19H22V5H20ZM21 18H3V20H21V18ZM4 19V5H2V19H4ZM9.05655 18.7226C9.34364 17.465 10.4204 16.5 12 16.5V14.5C9.49751 14.5 7.60375 16.1003 7.10672 18.2774L9.05655 18.7226ZM12 16.5C13.5796 16.5 14.6564 17.465 14.9435 18.7226L16.8933 18.2774C16.3962 16.1003 14.5025 14.5 12 14.5V16.5Z"
        fill="currentColor"
      />
      <path
        d="M17.75 8.25H17.76M18 8.25C18 8.38807 17.8881 8.5 17.75 8.5C17.6119 8.5 17.5 8.38807 17.5 8.25C17.5 8.11193 17.6119 8 17.75 8C17.8881 8 18 8.11193 18 8.25Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </CentralIconBase>
  );
};

export default IconStreaming;
